// LinkedIn Share Button Component
import React from 'react';
import styled from 'styled-components';
import { FaLinkedinIn } from 'react-icons/fa';

const ShareButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.07);
  color: rgba(10, 255, 112, 0.9);
  border: 1px solid rgba(10, 255, 112, 0.2);
  border-radius: 4px;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  svg {
    font-size: 14px;
  }
  
  &:hover {
    background: rgba(10, 255, 112, 0.1);
    border-color: rgba(10, 255, 112, 0.3);
    transform: translateY(-2px);
  }
`;


const LinkedInShareButton = ({ achievement, userId, verification_id }) => {
    const handleShareToLinkedIn = () => {
        // Generate verification number (in a real app, this would be stored in your database)
      const verificationNumber = verification_id;

        // Format certificate title - replace spaces with underscores
        const certificateTitle = achievement.title.replace(/\s+/g, '_');

        // Create certification details
      const certificationName = `CyberHub_${certificateTitle}`;
      const certificationUrl = `https://chief.thecyberhub.in/verify/${verificationNumber}`;

        // Get current date for issueYear and issueMonth
        const currentDate = new Date();
        const issueYear = currentDate.getFullYear();
        const issueMonth = currentDate.getMonth() + 1;

        // Compose LinkedIn share URL with certification parameters
        const linkedinShareUrl = new URL('https://www.linkedin.com/profile/add');

        // Add LinkedIn parameters for certification
        linkedinShareUrl.searchParams.append('startTask', 'CERTIFICATION_NAME');
        linkedinShareUrl.searchParams.append('name', certificationName);
      linkedinShareUrl.searchParams.append('organizationId', "96123947");
        linkedinShareUrl.searchParams.append('issueYear', issueYear);
        linkedinShareUrl.searchParams.append('issueMonth', issueMonth);
        linkedinShareUrl.searchParams.append('certUrl', certificationUrl);
        linkedinShareUrl.searchParams.append('certId', verificationNumber);

        // Open LinkedIn in a new tab
        window.open(linkedinShareUrl.toString(), '_blank');

        // Track the share event (optional)
        if (typeof achievement.onShare === 'function') {
            achievement.onShare('linkedin');
        }

        // Log share event for analytics (optional)
        console.log(`Shared badge: ${achievement.title} with verification #${verificationNumber} to LinkedIn`);
    };

    return (
        <ShareButton onClick={handleShareToLinkedIn}>
            <FaLinkedinIn /> Share
        </ShareButton>
    );
};

export default LinkedInShareButton;